export default {
  "ATP_APP_VIEW": "ATP_APP_VIEW",
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW",
  "APP_PWA_STANDALONE_ACCESS": "APP_PWA_STANDALONE_ACCESS"
} as any